import type { RfqPackage } from '../types';

type ReleaseLinkedPackage = Pick<RfqPackage, 'hubFileReleaseId' | 'hubFileReleaseIds'>;

/**
 * Every staged hub release a package carries. Suppliers-tab sends carry one;
 * Files → RFQs rounds publish one package per supplier that spans one release
 * per structure (`hubFileReleaseIds`, with `hubFileReleaseId` = the first).
 */
export function packageHubReleaseIds(pkg: ReleaseLinkedPackage | null | undefined): string[] {
  if (!pkg) return [];
  const out: string[] = [];
  const seen = new Set<string>();
  const push = (id: unknown) => {
    const v = typeof id === 'string' ? id.trim() : '';
    if (v && !seen.has(v)) {
      seen.add(v);
      out.push(v);
    }
  };
  push(pkg.hubFileReleaseId);
  for (const id of pkg.hubFileReleaseIds ?? []) push(id);
  return out;
}

/** True when the package was published from this staged release (alone or as part of a round). */
export function packageCoversHubRelease(pkg: ReleaseLinkedPackage | null | undefined, releaseId: string | undefined): boolean {
  const wanted = (releaseId || '').trim();
  if (!wanted) return false;
  return packageHubReleaseIds(pkg).includes(wanted);
}
